<template>
	<div id="chooseContact">
		<el-table :data="tableData" stripe style="width: 100%"
			:header-cell-style="{background:'#ECECEF',color:'#909399'}">
			<el-table-column prop="index" label="序号">
			</el-table-column>
			<el-table-column prop="name" label="姓名">
			</el-table-column>
			<el-table-column prop="phone" label="手机号">
			</el-table-column>
			<el-table-column label="地址">
				<template slot-scope="scope">
					<span>{{scope.row.province_name}}{{scope.row.city_name}}{{scope.row.areas_name}}{{scope.row.address}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<span class="col-text point" style="color: #B89DC1;" @click="yes(scope.row)"><i class="el-icon-zoom-in pr2"></i>选择</span>
					<span class="col-text point pl10" style="color: #A8B5C7;" @click="openAddContact(scope.row)"><i class="el-icon-setting pr2"></i>编辑</span>
				</template>
			</el-table-column>
		</el-table>
		
		<div class="ta-r pt10">
			<el-button size="small" style="background-color: #ffffff; padding: 10px 35px" class="fs14 rad25" icon="el-icon-circle-plus"
				@click="openAddContact()">新增联系人</el-button>
		</div>

		<my-dialog :title="addDialogTitle" path="contribution/addcontact.vue" ref="addContact" width="600px" yes
			@ok="afterAddContact"></my-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				addDialogTitle: "添加联系人",
				tableData: []
			};
		},
		methods: {
			init() {
				let searchData = {
					page: "1__100",
					sort: "id__desc"
				}

				this.$api.contribute
					.getMemberContact(searchData)
					.then((res) => {
						res.List.forEach((item, index) => {
							item.index = index + 1;
						})
						console.log(res.List);
						this.tableData = res.List
					})
					.catch((res) => {});
			},

			// 展示新增联系人弹层
			openAddContact(memberContact) {
				this.addDialogTitle = memberContact === undefined ? "新增联系人" : "编辑联系人";
				this.$refs.addContact.show(memberContact);
			},

			afterAddContact() {
				console.log("添加会员联系方式成功");
				let searchData = {
					page: "1__100",
					sort: "id__desc"
				}
				this.$api.contribute
					.getMemberContact(searchData)
					.then((res) => {
						res.List.forEach((item, index) => {
							item.index = index + 1;
						})
						console.log(res.List);
						this.tableData = res.List
					})
					.catch((res) => {});
			},

			yes(chooseContact) {
				this.$emit("ok", chooseContact);
				this.$emit("hide");
			},
		},
	};
</script>

<style lang="scss" scoped>
	.col-text {
		color: #5090f0;
	}

	.el-table {
		border-left: 1px solid #ececef;
		border-right: 1px solid #ececef;

		.el-table td,
		.el-table th {
			padding: 7px 0 !important;
		}
	}

	.el-table .caret-wrapper {
		height: 23px;

		.sort-caret.ascending {
			top: 0px;
		}

		.sort-caret.descending {
			bottom: 1px;
		}
	}

	thead th {
		padding: 4px !important;
	}
</style>
